import styled from 'styled-components'
const OrderSummaryDetailWrapper = styled.div`
  .summary-row {
    font-size: 13px;
    display: flex;
    align-items: flex-start;
    gap: 8px;
    padding: 6px 0;
    border-bottom: 1px dashed ${(props) => props.theme.tokens.borderSubtle};
  }

  .summary-row.inline {
    align-items: center;
    flex-wrap: wrap;
  }

  .summary-row:last-of-type {
    border-bottom: none;
  }

  .summary-icon {
    color: ${(props) => props.theme.tokens.textMuted};
    margin-top: 4px;
    flex-shrink: 0;
  }

  .summary-row.inline .summary-icon {
    margin-top: 0;
  }

  .summary-label-inline {
    color: ${(props) => props.theme.tokens.textMuted};
    flex-shrink: 0;
    font-weight: 500;
  }

  .summary-content {
    flex: 1;
    min-width: 0;
  }

  .summary-label {
    font-weight: 500;
    margin-bottom: 4px;
  }

  .shipping-image-container {
    display: inline;
    flex-wrap: wrap;
  }

  .shipping-image-container > img,
  .shipping-image-container > a > img {
    border: 1px solid ${(props) => props.theme.tokens.border};
    border-radius: 1px;
    padding: 1px;
    margin: 1px;
    width: 60px;
  }

  .sale-pipeline-section {
    margin-top: 4px;
    .sale-pipeline-card {
      width: 100%;
    }
  }

  .quick-actions .ant-space-item > div {
    margin: 0;
    align-items: flex-start;
  }

  .quick-actions .sale-pipeline-section {
    margin-top: 0;
  }

  .quick-actions .sale-pipeline-card {
    width: auto;
  }
`
export default OrderSummaryDetailWrapper
